import React from 'react';
import PropTypes from 'prop-types';

import './CFSForm.css';
import CFSForm from './CFSForm';
import CFSSummary from './CFSSummary';

export default class CallForSpeakers extends React.PureComponent {
    constructor(props) {
        super(props);
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        this.props.resetFormAction();
    }

    onSubmit = event => {
        event.preventDefault();
        if (this.isValidForm()) {
            this.props.submitCFSForm();
        }
    };

    closeAlert = () => {
        this.props.updateFormStatus('formFailed', false);
    };

    isValidValue = fieldName => {
        const field = this.props.fields[fieldName];
        const value = fieldName === 'disclaimer' ? field.value : field.value.trim();
        return field.touched ? value : true;
    };

    isValidSpeakerValue = (id, fieldName) => {
        const { fields } = this.props;
        const { speakers } = fields;
        const matchSpeaker = speakers.find(s => s.id === id);
        const field = matchSpeaker[fieldName];
        const value = field.value.trim();
        return field.touched ? value : true;
    };

    isValidForm = () =>
        !Object.keys(this.props.fields).find(key => {
            if (key === 'speakers') {
                return this.props.fields.speakers.find(speaker =>
                    Object.keys(speaker).find(speakerKey => {
                        if (speakerKey === 'id') {
                            return false;
                        }
                        return speaker[speakerKey].value.length === 0;
                    })
                );
            }

            if (key === 'disclaimer') {
                return !this.props.fields[key].value;
            }

            return this.props.fields[key].value.length === 0;
        });

    updateValue = event => {
        const { name } = event.target;
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        this.props.updateCFSFieldValue(name, value);
    };

    updateSpeaker = (id, event) => {
        const { name } = event.target;
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;

        this.props.updateSpeaker(id, name, value);
    };

    render() {
        const { addSpeaker, removeSpeaker } = this.props;
        const title = this.props.formSubmitted ? (
            <div className="page-header text-center cfs-form">
                <h1 className="title">Call for Speakers submitted successfully</h1>
            </div>
        ) : (
            <div className="page-header text-center cfs-form">
                <h1 className="title">Call for Speakers</h1>
            </div>
        );

        const fieldsRequired = !this.props.formSubmitted ? (
            <h3 className="text-center fields-req cfs-form">
                <strong>
                    <p className="text-danger">All fields are required.</p>
                </strong>
            </h3>
        ) : null;

        const content = this.props.formSubmitted ? (
            <CFSSummary fields={this.props.fields} />
        ) : (
            <CFSForm
                addSpeaker={addSpeaker}
                closeAlert={this.closeAlert}
                fields={this.props.fields}
                formFailed={this.props.formFailed}
                formSubmitInProgress={this.props.formSubmitInProgress}
                isValidForm={this.isValidForm}
                isValidSpeakerValue={this.isValidSpeakerValue}
                isValidValue={this.isValidValue}
                onSubmit={this.onSubmit}
                removeSpeaker={removeSpeaker}
                updateSpeaker={this.updateSpeaker}
                updateValue={this.updateValue}
            />
        );

        return (
            <section className="section" id="cfs">
                <div className="container call-for-speakers">
                    {title}
                    {fieldsRequired}
                    {content}
                </div>
            </section>
        );
    }
}

CallForSpeakers.propTypes = {
    addSpeaker: PropTypes.func.isRequired,
    // eslint-disable-next-line
    fields: PropTypes.object.isRequired,
    formFailed: PropTypes.bool.isRequired,
    formSubmitInProgress: PropTypes.bool.isRequired,
    formSubmitted: PropTypes.bool.isRequired,
    removeSpeaker: PropTypes.func.isRequired,
    resetFormAction: PropTypes.func.isRequired,
    submitCFSForm: PropTypes.func.isRequired,
    updateCFSFieldValue: PropTypes.func.isRequired,
    updateFormStatus: PropTypes.func.isRequired,
    updateSpeaker: PropTypes.func.isRequired
};
